import { call, put, takeLatest, all } from 'redux-saga/effects';
import notification from '../../services/notification';
import api from '../../services/api';
import types from '../types';
import { uploadFile } from '../../services/helpers';

function* getReferrals({ payload }) {
  try {
    const { status, data } = yield call(api.referrals.getReferrals, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_REFERRALS_SUCCESS, payload: data.data });
  } catch (error) {
    yield put({ type: types.GET_REFERRALS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getReferralsExcel({ payload }) {
  try {
    const { status, data } = yield call(api.referrals.getReferralsExcel, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    console.log(data);
    yield put({ type: types.GET_REFERRALS_EXCEL_SUCCESS, payload: data });
    if (data?.url) {
      payload.setXLSXUrl(data?.url);
    }
  } catch (error) {
    yield put({ type: types.GET_REFERRALS_EXCEL_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
    console.log(error);
  }
}

function* getReferralsXml({ payload }) {
  try {
    const { status, data } = yield call(api.referrals.getReferralsXml, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    console.log(data.url);
    yield put({ type: types.GET_REFERRALS_XML_SUCCESS, payload: data });
    if (data?.url) {
      uploadFile(data?.url.replace('public/', ''));
    }
  } catch (error) {
    yield put({ type: types.GET_REFERRALS_XML_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getReferralsStatistics({ payload }) {
  try {
    const { status, data } = yield call(
      api.referrals.getReferralsStatistics,
      payload,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_REFERRALS_STATISTICS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_REFERRALS_STATISTICS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getUserListOfReferrals({ payload }) {
  try {
    const { status, data } = yield call(
      api.referrals.getUserListOfReferrals,
      payload,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_USER_LIST_OF_REFERRALS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_USER_LIST_OF_REFERRALS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getUserfReferralsBonuses({ payload }) {
  try {
    const { status, data } = yield call(
      api.referrals.getUserfReferralsBonuses,
      payload,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_USER_REFERRALS_BONUSES_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_USER_REFERRALS_BONUSES_FAILURE });
    if (error?.response?.status === 401) return;
    if (
      error?.response?.data?.errors &&
      error?.response?.data?.errors?.to?.includes('invalid_date_range')
    ) {
      notification({
        type: 'error',
        message: 'The from date value cannot exceed the to date value',
      });
      return;
    }

    notification({ type: 'error', message: 'Something went wrong' });
  }
}

export function* referrals() {
  yield all([
    yield takeLatest(types.GET_REFERRALS_START, getReferrals),
    yield takeLatest(types.GET_REFERRALS_EXCEL_START, getReferralsExcel),
    yield takeLatest(types.GET_REFERRALS_XML_START, getReferralsXml),
    yield takeLatest(types.GET_REFERRALS_STATISTICS_START, getReferralsStatistics),
    yield takeLatest(types.GET_USER_LIST_OF_REFERRALS_START, getUserListOfReferrals),
    yield takeLatest(
      types.GET_USER_REFERRALS_BONUSES_START,
      getUserfReferralsBonuses,
    ),
  ]);
}
